// Utility functions for RecipientFilter component

export const getSelectedUserUIDs = (formValues) => {
  if (formValues.isAllMembers) {
    return [];
  }

  if (formValues.selectedRecipient?.value === "member") {
    if (formValues.selectedMemberType?.value === "lead") {
      return (
        formValues.selectedFollowUpMembers
          ?.map((member) => member?.value)
          .filter((id) => id && id !== "" && id !== null && id !== undefined) ||
        []
      );
    } else {
      return (
        formValues.selectedMembers
          ?.map((member) => member?.value)
          .filter((id) => id && id !== "" && id !== null && id !== undefined) ||
        []
      );
    }
  } else if (formValues.selectedRecipient?.value === "trainer") {
    return (
      formValues.selectedTrainers
        ?.map((trainer) => trainer?.value)
        .filter((id) => id && id !== "" && id !== null && id !== undefined) ||
      []
    );
  } else if (formValues.selectedRecipient?.value === "receptionist") {
    return (
      formValues.selectedReceptionists
        ?.map((receptionist) => receptionist?.value)
        .filter((id) => id && id !== "" && id !== null && id !== undefined) ||
      []
    );
  } else if (formValues.selectedRecipient?.value === "cluster_manager") {
    return (
      formValues.selectedClusterManagers
        ?.map((manager) => manager?.value)
        .filter((id) => id && id !== "" && id !== null && id !== undefined) ||
      []
    );
  }

  // Fallback for direct user selection (backward compatibility)
  return formValues.selectedUsers?.map((user) => user.value) || [];
};

export const getRecipientFilterDefaults = () => ({
  selectedRecipient: "",
  selectedMemberType: "",
  selectedMembers: [],
  selectedFollowUpMembers: [],
  selectedTrainers: [],
  selectedReceptionists: [],
  selectedClusterManagers: [],
  isAllMembers: false,
  selectedGym: "",
  selectedSubscriptionType: "",
  subscriptionTypeValue: "",
  selectedPlanDuration: "",
  selectedLeadSource: "",
  startDate: "",
  endDate: "",
});

export const mergeRecipientFilterDefaults = (existingDefaults) => ({
  ...existingDefaults,
  ...getRecipientFilterDefaults(),
});
